// ServiceOverview/ServiceOverviewCache.js
// Map<instance, PluginState>. Instance is technically the rk.
import CoreBase from '../../../services/engines/CoreBase';

const _name = 'ServiceOverviewCache';

class ServiceOverviewCache extends CoreBase {
    _name = _name;

    _items = new Map();

    /**
     * Initial REST fetch is the full registry — replaces the map.
     * @param {object[]} items
     */
    setAll = (items) => {
        this._items = new Map(items.map((i) => [i.instance, i]));
    };

    /**
     * SignalR push — overwrites per instance.
     * @param {object|object[]} data
     */
    addOrUpdate = (data) => {
        const items = Array.isArray(data) ? data : [data];
        items.forEach((i) => i?.instance && this._items.set(i.instance, i));
    };

    getAll = () => [...this._items.values()];

    clear = () => {
        this._items.clear();
    };
}

const serviceOverviewCache = new ServiceOverviewCache();
export default serviceOverviewCache;
